export default "__VITE_ASSET__BX372j9x__"